import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { buildReportPath } from '../utils/reportUrlUtils';

const REPORT_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const ReportLegacyRedirect = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!id || !REPORT_ID_PATTERN.test(id)) {
            navigate('/reports', { replace: true });
            return;
        }

        const source = searchParams.get('source') || 'LegacyReport';
        const slugLabel = searchParams.get('slug') || 'report';

        navigate(buildReportPath({ id, source, slugLabel }), { replace: true });
    }, [id, navigate, searchParams]);

    return (
        <p role="status" aria-live="polite">
            Redirecting to report...
        </p>
    );
};
